import { createAsyncAction } from "typesafe-actions";
import { DocumentResponse } from "../../models/document/DocumentResponse";
import { GetDocumentActionTypes } from "./types";

export const getDocumentActions = createAsyncAction(
    GetDocumentActionTypes.REQUEST,
    GetDocumentActionTypes.SUCCESS,
    GetDocumentActionTypes.ERROR
)<string, DocumentResponse, undefined>();
